import { Box, Center, Image } from '@mantine/core';
import './BackgroundVideoStyle.css'
import Warehouse from '../../../assets/modern-construction-materials-warehouse-with-organ.jpg';

export const BackgroundVideo = () : JSX.Element => {
  return (
    <Box
      style={{
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100vw',
        height: '100%',
        overflow: 'hidden',
        zIndex: 0,
      }}
    >
      {/* <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      >
        <source
          src="https://storage.googleapis.com/method-materials-dev-background-video/background-video.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video> */}
        <Image src={Warehouse} alt="warehouse background" style={{ objectFit: 'cover', backgroundPosition: 'center center', width: '100%', height: '100%' }} />
    {/* Gradient Overlay */}
      <Box
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.90), rgba(255, 255, 255, 0.90))',
        }}
      />
    </Box>
  );
}
